import React from 'react';
import { Container } from 'react-bootstrap';
import LoginPanel from '../components/LoginPanel';

function LoginPage() {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <Container className="d-flex align-items-center justify-content-center mt-5">
        <LoginPanel />
      </Container>
    </div>
  );
}


export default LoginPage;


